import { definePropType } from "@types-vue/props";
import { defineComponent } from "vue";
import TaskCenterItem from "./task-center-item.vue";
export default defineComponent({
    props: {
        data: {
            type: definePropType(Array),
            required: true
        }
    },
    components: {
        TaskCenterItem: TaskCenterItem
    },
    setup: function setup() {
        return {};
    }
});
